<template>
	<transition name="modal">
		<div  v-shortkey="['esc']" @keyup.up="up()" @keyup.down="down()" @keyup.enter="enter()" @shortkey="$emit('close')" class="modal-mask" v-show="show">
			<div class="modal-container">
				<div class="modal-header">
					<h3>Adicionar Diagnostico</h3>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-12">
							<input v-shortkey="['ctrl', 'b']" @shortkey="getDataTable()" title="pressione ctrl + b para pesquisar" ref="nmDiagnostico" type="text" class="form-control" v-model="filtros.pesquisa" @keyup.enter="getDataTable()" placeholder="Pesquisa: Entre com o nome ou código CID do diagnóstico e pressione ctrl + b ." />
						</div>
					</div>
					<div class="row" v-if='loading'>
						<div class="col-sm-12" style="text-align: center; margin-top:30px;">
							<br/>
							<span style="text-align: center">Aguarde, processando...</span>
						</div>
					</div>
					<div class="row" style="margin-top:15px" v-else>
						<div class="col-sm-12 table-responsive">
							<table role="grid" class="table table-bordered table-striped table-hover">
								<thead>
									<tr role="row">
										<th style="width: 10%">Código CID</th>
										<th style="width: auto">Nome</th>
										<th style="width: auto">Sexo</th>
									</tr>
								</thead>
								<tbody>
									<tr @click="seleciona(item)" :class="{'ativa': index === diagnosticoSelecionadoIndex}" class="even hand" role="row" v-for="(item, index) in dataTable.data" :key="index">
										<td>{{ item.cid }}</td>
										<td>{{ item.nome }}</td>
										<td>{{ item.sexo | sexo }}</td>
									</tr>
								</tbody>
							</table>
							<div class="row">
								<div class='col-sm-5'>
									Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.
								</div>
								<div class='col-sm-7' style="text-align:right">
									<laravue-pagination :data="dataTable" v-on:pagination-change-page="getDataTable">
										<span slot="prev-nav">&lt; Anterior</span>
										<span slot="next-nav">Próximo &gt;</span>
									</laravue-pagination>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="text-right" style="float:right">
						<button class="btn btn-default" @click="$emit('close')">
								<i class="fa fa-close"></i> Fechar
							</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	import axios from "axios"; // Cliente para requisição http
	export default {
		props: ["show", "unidadeId"],
		
		watch:{
			"$props.show": function () {
				this.$nextTick(function () {
					this.$refs.nmDiagnostico.focus(); 
				})				
			}		
			},

		filters: {
			"sexo": function(val) {
				if (val == 0) {
					return 'Ambos';
				} else if (val == 1) {
					return 'Masculino';
				} else if (val == 2) {
					return 'Feminino';
				}
			}
		},
		data: () => ({
			loading: false,
			diagnosticoSelecionadoIndex: 0,
			dataTable: {
				data: []
			},
			filtros: {
				pesquisa: '',
			}
		}),
		mounted() {
			this.getDataTable();			
		},
		methods: {
			getDataTable(page) {

				if (typeof page === 'undefined') {
					page = 1;
				}
				this.loading = true;
				this.filtros.page = page;
				this.$store.commit('TOGGLE_LOADING');
				this.diagnosticoSelecionadoIndex = 0;

				let config = this.$store.getters.getHeaderAuth;
				config.params = this.filtros;

				axios.get(`${this.$store.state.serverURI}/api/cadastros/diagnosticos/getAllPaginate`, config)
					.then(response => {
						this.dataTable = response.data;
						this.loading = false;
						this.$store.commit('TOGGLE_LOADING');
					}).catch((error) => {
						this.loading = false;
						console.log(error);
					});

			},
			up() {
				if (this.diagnosticoSelecionadoIndex > 0) {
							this.diagnosticoSelecionadoIndex--;
				}
				console.log("diagnosticoSelecionadoIndex : " + this.diagnosticoSelecionadoIndex);
			},
			down() {
				if (this.diagnosticoSelecionadoIndex < this.dataTable.data.length - 1) {
					this.diagnosticoSelecionadoIndex++;
				}
				console.log("diagnosticoSelecionadoIndex : " + this.diagnosticoSelecionadoIndex);			
			},
			enter() {
				this.seleciona(this.dataTable.data[this.diagnosticoSelecionadoIndex]);				
			},
			seleciona(diagnostico) {
				this.showModal = false;
				this.$emit('addDiagnosticoSelecionado', diagnostico);
			},			
		},		
		components: {},
	};
</script>

<style scoped>
	* {
		box-sizing: border-box;
	}

	.modal-mask {
		position: fixed;
		z-index: 1000;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		transition: opacity 0.3s ease;
	}

	.modal-container {
		width: 70%;
		margin: 40px auto 0;
		padding: 10px;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transition: all 0.3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}

	.modal-header h3 {
		margin-top: 0;
		color: #333;
	}

	.modal-body {
		margin: 10px 0;
	}

	.text-right {
		text-align: right;
	}

	.form-label {
		display: block;
		margin-bottom: 1em;
	}

	.form-label>.form-control {
		margin-top: 0.5em;
	}

	.form-control {
		display: block;
		width: 100%;
		padding: 0.5em 1em;
		line-height: 1.5;
		border: 1px solid #ddd;
	}


	/*
											 * The following styles are auto-applied to elements with
											 * transition="modal" when their visibility is toggled
											 * by Vue.js.
											 *
											 * You can easily play with the modal transition by editing
											 * these styles.
											 */

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}

	.modal {
		display: block !important;
		/* I added this to see the modal, you don't need this */
	}


	/* Important part */

	.modal-dialog {
		overflow-y: initial !important;
	}

	.modal-body {
		height: 350px;
		overflow-y: auto;
	}
</style>



// WEBPACK FOOTER //
// modalAddDiagnosticos.vue?3e6a52ed